// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2lyS1","label":"styles_label__1qOx5"};